import Icon from "components/Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import UploadContactsPictureModal from "./UploadContactsPictureModal.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import Form from "components/Reusable/Form/Form.js";
import contactFormFields from "./contactFormFields.jsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import config from "config.ts";

const ContactEditImageComponent = ({ setContactList, details }) => {
  const { setModal, closeModal } = useModal();
  const { getTextByKey } = useContent();

  const contactEmail =
    details && details.contact_list_email ? details.contact_list_email : null;
  const isOwnerPicture =
    details && details.contact_list_is_owner_image
      ? details.contact_list_is_owner_image
      : false;

  const deleteContactProfilePicture = async () => {
    const response = await apiRequest(
      "ContactsLists",
      `DeleteContactProfilePicture?contactEmail=${contactEmail}`,
      null,
      "POST"
    );
    // set contactList picture to null if success
    if (response.status === "success") {
      setContactList((prev) => {
        return prev.map((item) => {
          if (item.contact_list_email === contactEmail) {
            return {
              ...item,
              contact_list_image: response.data ? response.data : null,
              contact_list_is_owner_image: false,
            };
          }
          return item;
        });
      });
    }

    closeModal();
  };
  return (
    <div className="action-buttons">
      <div
        className="edit-picture"
        onClick={() =>
          setModal(() => (
            <UploadContactsPictureModal
              contactImage={details.contact_list_image}
              contactEmail={contactEmail}
              setContactList={setContactList}
            />
          ))
        }
      >
        <div className="profile-img-icon">
          <i className="fa fa-camera camProfileIcon"></i>
        </div>
        {getTextByKey("profileuserdetails-upload-new-profile-btn")}
      </div>
      {isOwnerPicture && (
        <div className="remove-picture" onClick={deleteContactProfilePicture}>
          <Tooltip
            id={"delete-picture"}
            tooltipTextKey={"profileuserdetails-remove-profile-picture-tooltip"}
          >
            <Icon name="trash-solid-b" gray className="profil-remove-icon" />
          </Tooltip>
        </div>
      )}
    </div>
  );
};

const ContactElementModal = ({
  isEdit,
  details,
  countFavoritesUsers,
  handleSubmit,
  fromSearch = null,
  setContactList,
}) => {
  const { getTextByKey } = useContent();
  const defaultAvatar = "avatar_default_large";

  const saveDetails = (body) => {
    if (fromSearch) {
      handleSubmit(body, details);
    } else {
      handleSubmit(body);
    }
  };

  return (
    <div className="contact-element-modal-container">
      {isEdit && (
        <div className="profile-avatar">
          {details.contact_list_favorite && (
            <div className="favorite-contact">
              <Icon name="star-solid" />
            </div>
          )}
          <div className="profile-img-text">
            {details.contact_list_image ? (
              <>
                <Image
                  src={details.contact_list_image}
                  name={!details.contact_list_image ? defaultAvatar : null}
                  ext={!details.contact_list_image && "png"}
                />
                <ContactEditImageComponent {...{ setContactList, details }} />
              </>
            ) : (
              <>
                <Image
                  src={
                    `${config.api.resource}/assets/images/avatar_default_large.png`
                  }
                  name={!details.contact_list_image ? defaultAvatar : null}
                  ext={!details.contact_list_image && "png"}
                />
                <ContactEditImageComponent {...{ setContactList, details }} />
              </>
            )}
          </div>
        </div>
      )}
      <Form
        onSubmit={saveDetails}
        fields={contactFormFields}
        fieldsProps={{ label: "hidden", field: "square" }}
        submitProps={{
          title: getTextByKey("save"),
          className: "new-button",
        }}
        defaultValuesObj={
          details
            ? {
                ContactName: details.contact_list_full_name,
                Email: details.contact_list_email,
                PhoneNumber: details.contact_list_phone,
                ContactListFavorite: details.contact_list_favorite,
              }
            : {}
        }
        externalProps={{
          countFavoritesUsers,
        }}
      />
    </div>
  );
};

export default ContactElementModal;
